<div role="cell">
  <ng-content></ng-content>
</div>
